<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">Editar DIFAL</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="cancelar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    @if (ufLabel) {
                    UF de destino:
                    <span class="status-badge badge-cinza ms-1">{{ ufLabel }}</span>
                    <span class="status-badge ms-1" [ngClass]="classeOrigemFormula()">{{ origemFormula }}</span>
                    } @else {
                    Defina as alíquotas e fórmulas da DIFAL por UF.
                    }
                </p>
            </div>
        </div>

        @if (isLoading) {
        <div class="difal-skeleton">
            <div class="skeleton-card">
                <div class="skeleton skeleton-line--title"></div>
                <div class="skeleton-grid">
                    <div class="skeleton skeleton-field"></div>
                    <div class="skeleton skeleton-field"></div>
                    <div class="skeleton skeleton-field"></div>
                </div>
            </div>
            <div class="skeleton-card">
                <div class="skeleton skeleton-line--title"></div>
                <div class="skeleton-grid">
                    <div class="skeleton skeleton-field"></div>
                </div>
            </div>
        </div>
        } @else {

        <form [formGroup]="form">

            <!-- Alíquotas -->
            <div class="section-container">
                <div class="section-title">
                    <mat-icon class="material-symbols-outlined">percent</mat-icon>
                    <span>Alíquotas</span>
                    <div class="section-title-actions ms-auto">
                        <button mat-button type="button" class="btn-section" (click)="abrirSimulacao()">
                            <mat-icon class="material-symbols-outlined">science</mat-icon>
                            Simular cálculo do DIFAL
                        </button>
                        <span class="personalizar-tooltip-wrap" [matTooltip]="personalizarTooltip"
                            [matTooltipDisabled]="!personalizarBloqueado">
                            <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount"
                                [matBadgeHidden]="personalizadasCount === 0" [disabled]="personalizarBloqueado"
                                (click)="abrirEditorFormulas()">
                                <mat-icon class="material-symbols-outlined">settings</mat-icon>
                                Personalizar fórmulas
                            </button>
                        </span>
                    </div>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota interna da UF de destino (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask"
                                formControlName="pIcmsUfDest">
                            @if (form.get('pIcmsUfDest')?.hasError('required') && form.get('pIcmsUfDest')?.touched) {
                            <mat-error>Informe a alíquota interna.</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota interestadual (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask"
                                formControlName="pIcmsInter">
                            @if (form.get('pIcmsInter')?.hasError('required') && form.get('pIcmsInter')?.touched) {
                            <mat-error>Informe a alíquota interestadual.</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota FCP da UF de destino (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask"
                                formControlName="pFcpUfDest">
                            <mat-icon matSuffix class="material-symbols-outlined" matTooltip="Sugestão: máximo de 2%."
                                matTooltipPosition="above">info</mat-icon>
                            @if (form.get('pFcpUfDest')?.hasError('required') && form.get('pFcpUfDest')?.touched) {
                            <mat-error>Informe a alíquota FCP.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Redução da base de cálculo -->
            <app-ativacao-section-card
                [control]="reducaoBcControl"
                titulo="Redução da base de cálculo"
                [exibirTituloNoAlerta]="false"
                descricaoAtivo="Redução ativa. O percentual abaixo reduz a base de cálculo da DIFAL desta UF."
                descricaoInativo="Redução inativa. A DIFAL desta UF será calculada sobre a base cheia."
                emptyStateTitulo="Redução da base de cálculo desativada"
                emptyStateDescricao="Ative a redução acima para informar o percentual aplicado sobre a base de cálculo da DIFAL.">
            </app-ativacao-section-card>

            @if (form.get('isReducaoBc')?.value) {
            <div class="section-container">
                <div class="section-title">
                    <mat-icon class="material-symbols-outlined">functions</mat-icon>
                    <span>Redução da base de cálculo</span>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Percentual de redução da BC (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask"
                                formControlName="pRedBcDifal">
                            @if (form.get('pRedBcDifal')?.hasError('required') && form.get('pRedBcDifal')?.touched) {
                            <mat-error>Informe o percentual de redução.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
            </div>
            }

        </form>
        }
    </div>
</div>

<app-footer-action salvarLabel="Salvar" [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading"
    (cancelar)="cancelar()" (salvar)="salvar()">
</app-footer-action>
